import type { ErrorComponentProps } from '@tanstack/react-router';
import { isApiError } from '@_/utils-frontend';
import { NotFoundPage } from './NotFoundPage.tsx';
import { ServerErrorPage } from './ServerErrorPage.tsx';

export function DefaultErrorBoundary({ error }: ErrorComponentProps) {
  if (isApiError(error)) {
    if (error.status === 401) {
      return;
    }

    if (error.status === 404) {
      return <NotFoundPage />;
    }

    if (error.status === 429) {
      // TODO: Render rate-limit error page
      return <ServerErrorPage />;
    }

    if (error.status >= 500) {
      return <ServerErrorPage />;
    }
  }

  if (import.meta.env.PROD) {
    return <ServerErrorPage />;
  }

  throw error;
}
